import { useTranslations } from "use-intl";

import AnimatedLoader from "../AnimatedLoader";
import { useHotelSearchResults } from "@/app/lib/hooks/useHotelSearchResults";
import { useHotelFiltersContext } from "@/app/lib/context/HotelFiltersContext";
import { useHotelSortContext } from "@/app/lib/context/HotelSortContext";
import { useHotelSearch } from "@/app/lib/hooks/useHotelSearch";
import { HotelCardList } from "./HotelCardList";
import { GhostIcon } from "@phosphor-icons/react";

export function MayLikeHotelsList() {
  const t = useTranslations();

  const { sortValue } = useHotelSortContext();
  const { filters } = useHotelFiltersContext();
  const { searchResultKey, searchResultToken, progress, isFetching } =
    useHotelSearch();

  const {
    data: searchResultData,
    isLoading: isLoadingData,
    isEmpty,
  } = useHotelSearchResults({
    searchResultKey,
    searchResultToken,
    filters,
    shouldFetch: progress === 100,
    sortValue,
  });

  return (
    <>
      {isFetching || isLoadingData ? (
        <>
          <AnimatedLoader icon="buildings" />
          <h3 className="mt-3 font-normal text-text-primary">
            {t("hotels.preparingBestOffers")}
          </h3>
        </>
      ) : (
        <>
          {isEmpty ? (
            <div className="flex h-full flex-col items-center">
              <div className="mt-[30%] flex flex-col items-center gap-4">
                <GhostIcon size={60} color="#0A22474D" />
                <span className="text-center text-sm text-text-primary">
                  {t("hotels.emptyState")}
                </span>
              </div>
            </div>
          ) : (
            <div className="w-full px-4">
              <HotelCardList
                hotels={searchResultData?.pages?.flatMap(
                  (hotels) => hotels.data,
                )}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}
